import { useState } from "react";
import { Button } from "@volca/ui/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@volca/ui/components/ui/dialog";
import { useUserManagementAccess } from "@/user/management-access";
import { UserAccountForm } from "@/user/user-account-form";
import { WelcomeEmailNotice } from "@/user/welcome-email-notice";

export const AddUser = ({
  businessId,
  onCreated,
}: {
  businessId: string;
  onCreated: (userId: string) => void;
}) => {
  const { canManageUsers } = useUserManagementAccess(businessId);
  const [open, setOpen] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const [failedEmailUserId, setFailedEmailUserId] = useState<string>();
  if (!canManageUsers) return null;
  return (
    <>
      <Button onClick={() => setOpen(true)}>Add user</Button>
      <UserAccountForm
        key={formKey}
        businessId={businessId}
        actionsAlign="end"
        onCancel={() => setOpen(false)}
        onSaved={(user, welcomeEmailFailed) => {
          setFailedEmailUserId(welcomeEmailFailed ? user.id : undefined);
          setOpen(false);
          setFormKey((current) => current + 1);
          onCreated(user.id);
        }}
        renderContent={(content) => (
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Add user</DialogTitle>
                <DialogDescription>
                  Create the account first, then set workbook access in the
                  draft.
                </DialogDescription>
              </DialogHeader>
              {content}
            </DialogContent>
          </Dialog>
        )}
      />
      {failedEmailUserId && (
        <Dialog open onOpenChange={() => setFailedEmailUserId(undefined)}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Account created</DialogTitle>
              <DialogDescription>
                The welcome email could not be sent. You can retry it here or
                from Users.
              </DialogDescription>
            </DialogHeader>
            <WelcomeEmailNotice userId={failedEmailUserId} failed />
            <Button onClick={() => setFailedEmailUserId(undefined)}>
              Continue to workbook access
            </Button>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
